import { Link } from "gatsby"
import PropTypes from "prop-types"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./DeploymentCards.module.css"

function isExternal(url) {
  return /^https?:\/\//.test(url || "")
}

function CardLink({ link, children }) {
  if (!link) return children
  if (isExternal(link)) {
    return (
      <a
        href={link}
        className={css.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    )
  }
  return (
    <Link to={link} className={css.link}>
      {children}
    </Link>
  )
}

CardLink.propTypes = {
  link: PropTypes.string,
  children: PropTypes.node,
}

function DeploymentCards({
  label,
  heading,
  description,
  descriptionHtml,
  cards,
}) {
  const subtitle = descriptionHtml ? (
    <span dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
  ) : (
    description
  )

  return (
    <Section padding="extraLight">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={subtitle}
        dash="vertical"
        narrow="both"
      />
      <div className={css.grid}>
        {cards?.map((card, index) => {
          const cardClass = `${css.card} ${card.highlighted ? css.cardHighlighted : ""}`
          const badgeClass = `${css.badge} ${card.highlighted ? css.badgeHighlighted : ""}`
          return (
            <div key={`deploy-card-${index}`} className={cardClass}>
              {card.badge && <span className={badgeClass}>{card.badge}</span>}
              <h3 className={css.heading}>{card.heading}</h3>
              {card.descriptionHtml ? (
                <div
                  className={css.description}
                  dangerouslySetInnerHTML={{ __html: card.descriptionHtml }}
                />
              ) : (
                <p className={css.description}>{card.description}</p>
              )}
              {card.link && (
                <CardLink link={card.link}>
                  {card.linkText || "Learn more"} →
                </CardLink>
              )}
            </div>
          )
        })}
      </div>
    </Section>
  )
}

DeploymentCards.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionHtml: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      description: PropTypes.string,
      descriptionHtml: PropTypes.string,
      badge: PropTypes.string,
      highlighted: PropTypes.bool,
      link: PropTypes.string,
      linkText: PropTypes.string,
    })
  ),
}

export default DeploymentCards
